export default __webpack_public_path__ + "static/media/logo-2.38fc9e29.png";